<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <div class="routine-component">
    <div class="routine-background lazyload" :data-bg="bgimage"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-4">
          <div class="routine-description">
            <h2 v-if="productDataset.content.title" v-html="productDataset.content.title"></h2>
            <p
              v-if="productDataset.content.description"
              v-html="productDataset.content.description"
            ></p>
            <h4
              v-if="productDataset.content.status_options"
              v-html="productDataset.content.status"
            ></h4>
            <div class="select-container">
              <label class="label-select" for="routine-select">Choose your hair type</label>
              <select
                id="routine-select"
                ref="statuschoice"
                name="routine-select"
                aria-label="ariaLabel"
                @change="changeStatus()"
              >
                <option
                  v-for="status in productDataset.content.status_options"
                  :key="status.url"
                  :value="status.url"
                  :selected="status.selected"
                >
                  {{ status.value }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-9 col-sm-8">
          <routine-products :carousel-identifier="carouselId">
            <div
              v-for="(product, index) in productDataset.products"
              :key="product.id"
              :slot="`product${index + 1}`"
              class="routine-product"
              :data-tagging-on-impression="JSON.stringify(product.tagging_impression)"
            >
              <div class="routinehover-item">
                <div class="routine routine-scale">
                  <div
                    class="routine-number"
                    :style="{
                      bottom: product.number.bottom,
                      left: product.number.left,
                      fontSize: product.number.size,
                    }"
                  >
                    {{ product.number.copy }}
                  </div>
                  <div
                    class="routine-title"
                    :style="{
                      bottom: product.title.bottom,
                      left: product.title.left,
                      fontSize: product.title.size,
                    }"
                  >
                    {{ product.title.copy }}
                  </div>
                  <media-item type="picture">
                    <media-picture
                      :filename="product.media.filename"
                      :alt="product.media.alt"
                      :lazy="true"
                      :sizes="product.media.sizes"
                    ></media-picture>
                  </media-item>
                  <a
                    v-tag="product.tagging_click"
                    :href="product.url"
                    @click="dataLayerPushFunction(product.tagging_product_click)"
                  >
                    <div v-if="productDataset.Routine_buy_now">
                      <div role="presentation">
                        <div class="routine-image-description">
                          <span class="routineimage-description-block">{{
                            productDataset.hover_state
                          }}</span>
                          <span
                            class="color-border-bar"
                            style="background-color: rgb(100 39 37)"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                <h3 v-if="product.name">{{ product.name }}</h3>
                <span v-if="product.productprice" class="routine-price-text">{{
                  product.productprice
                }}</span>
                <span class="custom-underline">
                  <a
                    v-if="productDataset.Routine_EnableorDisable"
                    :href="product.url"
                    aria-label="Product ratings"
                  >
                    <rfp-rare-star-ratings
                      :rating="product.overallproductrating"
                      :star-rating-increment-value="1"
                      :star-rating-max-rating-value="5"
                      star-rating-inactive-color="#e0e0e0"
                      star-rating-active-color="#242424"
                      :star-rating-star-size="15"
                      :star-ratings-taging="product.TaggingRatesAndReviewsAttributes"
                      :counts="product.totalratingcount"
                      :review-text="product.reviewtext"
                    ></rfp-rare-star-ratings>
                  </a>
                  <div
                    v-if="Enable_Bv"
                    data-bv-show="inline_rating"
                    :data-bv-product-id="product.ean"
                    :data-bv-redirect-url="product.url"
                    data-bv-seo="false"
                  ></div>
                </span>
                <p v-if="product.description">{{ customTruncate(product.description) }}</p>
              </div>
              <template v-if="productDataset.is_ecommerce_enabled">
                <product-purchase
                  :list-price-template="productDataset.list_price_template"
                  :add-to-cart-tagging="product.add_to_cart_tagging"
                  :price-template="productDataset.price_template"
                  :single-price-template="productDataset.single_price_template"
                  :installments-template="productDataset.installments_template"
                  :discounts-template="productDataset.discounts_template"
                  :unavailable-text="productDataset.unavailable_text"
                  :buy-text="productDataset.buy_text"
                  :api-url="productDataset.api_url"
                  :ean="product.ean"
                />
              </template>
              <template v-else>
                <div
                  v-if="
                    productDataset['Routine_mctb'] && product.retailer && product.retailer.length
                  "
                >
                  <routine-addtocart-popin-button
                    :show-btn="productDataset['Routine_mctb']"
                    :btn-name="productDataset['Routine_mctb_text']"
                    :product="product"
                    :product-dataset="productDataset"
                  />
                </div>
                <div v-else>
                  <div v-if="productDataset.Routine_buy_now && product.Purchase_Link != '#'">
                    <a
                      v-tag="product.purchase_button_tagging"
                      :href="product.Purchase_Link"
                      target="_blank"
                      class="routineproduct-button ripple-animation ripple-animation--black"
                      >{{ product.link_text }}</a
                    >
                  </div>
                  <div v-if="productDataset.Routine_buy_now === false">
                    <a
                      v-tag="product.tagging_click"
                      :href="product.url"
                      class="more-information"
                      @click="dataLayerPushFunction(product.tagging_product_click)"
                      >{{ productDataset.content.more_information_copy }}</a
                    >
                  </div>
                </div>
              </template>
            </div>
          </routine-products>
          <loadingoverlay :showing="showOverlay" loadingtext="loading products"></loadingoverlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'whatwg-fetch';
import LoadingOverlay from '../loading-overlay/loading-overlay.vue';
import truncateSave from '../../utilities/truncate';
import RoutineAddtocartPopinButton from '../routine-multi/routine-addtocart-popin-button.vue';

export default {
  name: 'routine-multi',
  components: {
    loadingoverlay: LoadingOverlay,
    RoutineAddtocartPopinButton,
  },
  props: {
    initialdata: { type: Object, required: true },
    Enable_Bv: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      taggingOnChange: {},
      selectedStatus: {},
      productDataset: this.initialdata,
      carouselId: `carousel-${Date.now()}`,
      bgimage: this.initialdata.background,
    };
  },
  mounted() {
    const selectLabel = this.$refs.statuschoice[0].label;
    this.fireAnalytics(selectLabel);
  },
  methods: {
    customTruncate(string) {
      return truncateSave(string, '80', { ellipsis: '...' });
    },
    triggerTagging(product) {
      dataLayer.push({
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'Ecommerce',
        eventAction: 'click to buy',
        eventLabel: `${product.name.toLowerCase()}${'::'}${product.ean || 'none'}`,
      });
    },
    checkStatus(response) {
      if (response.status >= 200 && response.status < 300) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    },

    parseJSON(response) {
      return response.json();
    },

    getNewProducts(url) {
      fetch(url)
        .then(this.checkStatus.bind(this))
        .then(this.parseJSON.bind(this))
        .then(this.onData.bind(this))
        .catch(this.onError.bind(this));
    },

    dataLayerPushFunction(datas) {
      dataLayer.push({
        eventCategory: datas.eventCategory,
        eventAction: datas.eventAction,
        event: datas.event,
        eventLabel: datas.eventLabel,
        event_name: datas.event_name,
        product_info: datas.product_info,
        ecommerce: {
          click: {
            actionField: {
              list: datas.ecommerce.click.actionField.list,
            },
            products: [
              {
                name: datas.ecommerce.click.products[0].name,
                id: datas.ecommerce.click.products[0].id,
                category: datas.ecommerce.click.products[0].category,
                brand: datas.ecommerce.click.products[0].brand,
                position: datas.ecommerce.click.products[0].position,
                dimension35: decodeURI(datas.ecommerce.click.products[0].dimension35),
                dimension36: decodeURI(datas.ecommerce.click.products[0].dimension36),
                dimension38: datas.ecommerce.click.products[0].dimension38,
                dimension48: datas.ecommerce.click.products[0].dimension48,
                dimension59: datas.ecommerce.click.products[0].dimension59,
                dimension91: 'none',
                variant: decodeURI(datas.ecommerce.click.products[0].variant),
              },
            ],
          },
        },
      });
    },

    onData(data) {
      this.productDataset = data;
      if (window.eventBus) {
        window.eventBus.$emit(`${this.carouselId}-gotoPage`, 0);
      }
    },

    onError(error) {
      console.error('request failed', error);
    },

    changeStatus() {
      this.selectedStatus =
        this.productDataset.content.status_options
          .filter((status) => status.url === this.$refs.statuschoice.value)
          .shift() || {};
      this.taggingOnChange = this.selectedStatus.tagging_onchange || {};
      /* istanbul ignore next */
      this.fireAnalytics(this.selectedStatus);
      /* istanbul ignore next */
      this.getNewProducts(this.$refs.statuschoice.value);
    },

    fireAnalytics(selectedVal) {
      try {
        dataLayer.push({
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'homepage',
          eventAction: 'select::' + [this.productDataset.content.title.toLowerCase() || 'none'],
          eventLabel:
            'filter by::' +
            [
              selectedVal.constructor === Object
                ? selectedVal.value.toLowerCase()
                : selectedVal.toLowerCase(),
            ],
        });
      } catch {
        console.warn('datalayer is not defined');
      }
    },
    starTagging(values1, values2, values3, values4, values5) {
      dataLayer.push({
        eventCategory: values1,
        eventAction: values2,
        eventLabel: values3,
        event: values4,
        Ecommerce: values5,
      });
    },
  },
};
</script>
